export default [
  {
    path: '/drilling-soal/tps',
    name: 'drilling-soal/tps',
    component: () => import('@/views/menu/drilling-soal/cooming-soon/cooming-soon.vue'),
    meta: {
      pageTitle: '',
      requireAuth: true,
    },
  },
  {
    path: '/drilling-soal/tka-saintek',
    name: 'drilling-soal/tka-saintek',
    component: () => import('@/views/menu/drilling-soal/cooming-soon/cooming-soon.vue'),
    meta: {
      pageTitle: '',
      requireAuth: true,
    },
  },
  {
    path: '/drilling-soal/tka-soshum',
    name: 'drilling-soal/tka-soshum',
    component: () => import('@/views/menu/drilling-soal/cooming-soon/cooming-soon.vue'),
    meta: {
      pageTitle: '',
      requireAuth: true,
    },
  },
]
